
const monthsFull = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December'
];

export function formatDate(dateStr) {
	const d = new Date(dateStr);
	return `${d.getDate()} ${monthsFull[d.getMonth()]} ${d.getFullYear()}`;
};



// WEBPACK FOOTER //
// ./src/helpers/dateUtils.js